import { type FC, type ReactNode } from "react";
import DefinitionTooltip, { type DefinitionTooltipInfo } from "../DefinitionTooltip";

interface DashboardPanelHeaderProps {
  title: string;
  definition: DefinitionTooltipInfo;
  align?: "start" | "end";
  actions?: ReactNode;
}

const DashboardPanelHeader: FC<DashboardPanelHeaderProps> = ({
  title,
  definition,
  align = "end",
  actions,
}) => {
  return (
    <div className="organic-content-panel__header">
      <div className="organic-content-panel__title">
        <h3>{title}</h3>
        <DefinitionTooltip label={title} info={definition} align={align} />
      </div>
      {actions}
    </div>
  );
};

export default DashboardPanelHeader;
